import module from "../monitorableModule"
import template from "./finishMonitorablesModal.html"


module.service("finishMonitorablesModal", [ "$modal",
    function ($modal) {
        return function (monitorableIds) {
            return $modal.open({
                template: template,
                size: "lg",
                backdrop: "static",
                controller: [ "$scope", "mbrService", "remoteMessageModal", "remoteExceptionHandler", "loadingService", function ($scope, mbrService, remoteMessageModal, remoteExceptionHandler, loadingService) {

                    $scope.finalizeMonitorableDTOs = []

                    $scope.init = function () {
                        monitorableIds.forEach(function (monitorableId) {
                            $scope.finalizeMonitorableDTOs.push({
                                monitorableId: monitorableId,
                                completionSource: "FrontEnd",
                                dateTime: Date.now()
                            })
                        })
                    }

                    $scope.init()

                    $scope.applyBatchDateTime = function () {
                        var firstDateTime = $scope.finalizeMonitorableDTOs[0].dateTime
                        for (let i = 1; i < $scope.finalizeMonitorableDTOs.length; i++) {
                            $scope.finalizeMonitorableDTOs[i].dateTime = firstDateTime
                        }
                    }

                    $scope.hasMonitorableWithoutNewDate = function () {
                        return !$scope.finalizeMonitorableDTOs.every((dto) => !!dto.dateTime)
                    }

                    $scope.hasAnyMonitorableDateAfterNow = function () {
                        let now = Date.now();
                        return $scope.finalizeMonitorableDTOs.some((dto) => {
                            if (!dto.dateTime) {
                                return false;
                            }
                            return dto.dateTime > now;
                        })
                    }

                    $scope.getErrorTooltip = function () {
                        if ( $scope.hasAnyMonitorableDateAfterNow() ) {
                            return "monitoring.monitorable.modal.finishMonitorables.erro.tooltip.dateTime.after.now"
                        }
                        return ""
                    }
                    
                    $scope.finish = function () {
                        loadingService(mbrService.finishMonitorablesAt($scope.finalizeMonitorableDTOs))
                            .catch(remoteExceptionHandler())
                            .then(function (remoteMessages) {
                                return remoteMessageModal(remoteMessages);
                            }).then( () => {
                                $scope.$close()
                            });
                    }
                }]
            }).result
        }
    }
])